// created by COGBEE
import React from 'react';
import { Stack, Icon, PrimaryButton, TextField, Separator, ActionButton } from '@fluentui/react';
import {
    paneFooterStyles,
    paneFooterTokens,
    footerMainTextStyle,
    textFieldStyles,
    copyLinkButtonStyle,
    copyIconStyle,
    rejectButtonStyle,
    noShowButtonStyle,
    RateLabelStyle,
    RatingButtonStyle
} from './styles/CommandPanel.styles';

import { ParticipantModel, ParticipantInfo } from 'Utils/participantInfo';
import { SetInput  } from 'Utils/SignalRConnection';

if (window.qText)
(document.getElementById("questiontext") as HTMLInputElement).value = window.qText; 

export default (): JSX.Element => {

    const modelone: ParticipantInfo = ParticipantModel();

    return (
        <Stack styles={paneFooterStyles} tokens={paneFooterTokens}>
            <Separator />
            {/*<div className={footerMainTextStyle}>{invitePeopleString}</div>*/}
            <div
                style={{
                    display: "inline-block",
                    paddingLeft: 5,
                    paddingRight: 0,
                    backgroundColor: "#ffffff",
                    width: "98%"
                }}
            >
                <div id="div3" style={{ height: 620 }} className="mCustomScrollbar _mCS_4">
                    <div
                        id="mCSB_4"
                        className="mCustomScrollBox mCS-dark mCSB_vertical mCSB_inside"
                        style={{ maxHeight: "none" }}
                        tabIndex={0}
                    >
                        <div
                            id="mCSB_4_container"
                            className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
                            style={{ position: "relative", top: 0, left: 0 }}
                            dir="ltr"
                        >
                            {/*<div*/}
                            {/*    style={{*/}
                            {/*        border: "0px solid #d9d9d9",*/}
                            {/*        width: "100%",*/}
                            {/*        color: "#0c44ac",*/}
                            {/*        lineHeight: "2.5em"*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    */}{/*<div style={{ paddingLeft: 10, fontWeight: 500 }}>*/}
                            {/*    */}{/*    Problem Statement*/}
                            {/*    */}{/*</div>*/}
                            {/*    <div style={{ height: 1, backgroundColor: "#e2e8f0" }} />*/}
                            {/*</div>*/}
                            <div style={{ backgroundColor: "#ffffff" }}>
                                <h5>
                                    <textarea
                                        id="questiontext"
                                        rows={uRole == "Candidate" ? 35 : 11}
                                        style={{
                                            height: "88%",
                                            fontSize: 13,
                                            width: "94%",
                                            border: "none",
                                            boxSizing: "unset",
                                            margin: 10,
                                            color: "black"
                                        }}
                                        readOnly={modelone.role =="Candidate"?true:false}
                                        defaultValue={window.qText ? window.qText : ""}
                                        onKeyUp={(event) => { SetInput("ps", "questiontext", true); window.qText = (document.getElementById("questiontext") as HTMLInputElement).value }}
                                    />
                                </h5>
                            </div>
                        </div>
                        <div
                            id="mCSB_4_scrollbar_vertical"
                            className="mCSB_scrollTools mCSB_4_scrollbar mCS-dark mCSB_scrollTools_vertical"
                            style={{ display: "none" }}
                        >
                            <a href="#" className="mCSB_buttonUp" />
                            <div className="mCSB_draggerContainer">
                                <div
                                    id="mCSB_4_dragger_vertical"
                                    className="mCSB_dragger"
                                    style={{ position: "absolute", minHeight: 30, top: 0, height: 0 }}
                                >
                                    <div className="mCSB_dragger_bar" style={{ lineHeight: 30 }} />
                                </div>
                                <div className="mCSB_draggerRail" />
                            </div>
                            <a href="#" className="mCSB_buttonDown" />
                        </div>
                    </div>
                </div>
            </div>
            
        </Stack>
    );
};